
import { Vue } from "vue-class-component";

export default class ChevronUpNew extends Vue {}
